import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'SolidCheckSvg',
  props: {
  width: {
    type: [String, Number],
    default: 10,
  },
  height: {
    type: [String, Number],
    default: 8,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    fill: "none",
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M3.57995 7.7093L0.384888 4.51424L1.97678 2.92235L3.56866 4.51424L7.56532 0.517578L9.15721 2.10947L3.57995 7.7093Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})